module.exports = __webpack_public_path__ + "media/images/carousel/banner_3-622d3afec2c3c93f9afbec8123cc2066.jpg";